import {router} from '../router'
import {store} from '../store/index.js'


export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
         //store.dispatch('alert/clear',{ root: true });
        if (!response.ok) {

            const error = (data && data.message) || response.statusText;
            //commit('registerFailure', error);
            console.log(error);
            store.dispatch('alert/error', "Napaka pri priklicu podatkov", { root: true });
            if (response.status === 401) {
                // auto logout if 401 response returned from api
             // store.dispatch('logout')
              //router.push('/login')
             //  location.reload(true);
                //location.reload(true);
               
               
                store.dispatch('account/logout','',{ root: true });
                store.dispatch('alert/error', error, { root: true });
                router.push('/login')
            }
            return Promise.reject(error);
        }

        return data;
    });
}

